module.exports = __webpack_public_path__ + "img/eyes_female_asian_thin_mask.19ff43cd.png";